<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="title" :subTitle="subTitle" :btnCalculateData="true" :btnBack="true"
                @btnCalculateDataClick="handleCalculateDataClick"
                @btnBackClick="handleBackClick"
        />
        <section :class="$style.body">

            <div :class="$style.footer">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="按天统计" name="first">
                        <DayItem ref="byDay" :index="index" :dateOne="dateOne"/>
                    </el-tab-pane>
                    <el-tab-pane label="按人统计" name="second">
                        <PeopleItem ref="byPeople" :index="index" :dateOne="dateOne"/>
                    </el-tab-pane>
                </el-tabs>

            </div>

            <div class="channel" align="center">
                <section style="margin-top: 5px" class="ware">
                    <div v-for="(item, index) in shiftArray" :key="index" :label="item" :span="8">
                        <div style="padding: 5px" v-if="item.shift_id">
                            <span :class="$style.span_shift" :style="{'background':getBackground(item.icon_color)}">{{item.icon_text}}</span>
                            <section style="margin-top: 5px">
                                <span>{{item.start_time}}-{{item.end_time}}</span>
                            </section>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>
</template>
<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import DayItem from './item/dayItem.vue'
    import PeopleItem from './item/peopleItem.vue'
    import {bus} from '../../../router/index.js'
    import moment from 'moment'
    export default {
        data () {
            return {
                loading: false,
                tags: ['考勤', '门店详情'],
                title: '门店',
                subTitle: '工时统计',
                activeName: 'first',

                store_id:'',
                dateOne:{},
                shiftArray: [],
            }
        },
        components: {
            navBar,
            DayItem,
            PeopleItem
        },
        computed: {
            isDisabled () {
                if (this.message) {
                    return false
                }
                return true
            }
        },
        created () {


            let obj = this.$store.getters.getStore
            this.store_id = obj.id
            this.title = obj.storeName
            this.shiftArray = obj.shiftArray

            if(obj.dateOne){
                this.dateOne = obj.dateOne
            }else {
                this.dateOne = moment()
            }

            bus.$on('setDate', (text) => {
                //隐藏编辑门店按钮
                this.dateOne = text

                this.$store.commit('setStore', {
                    id: this.store_id,
                    dateOne:this.dateOne,
                    storeName: this.title,
                    shiftArray:this.shiftArray
                })
            })

            bus.$on('setShiftArray', (text) => {

                this.shiftArray = text

                this.$store.commit('setStore', {
                    id: this.store_id,
                    dateOne:this.dateOne,
                    storeName: this.title,
                    shiftArray:this.shiftArray
                })
            })

        },
        methods: {

            // tab切换
            handleClick(tab) {

                if (tab.index === "0") {
                    this.activeName = 'first'
                    this.$refs.byDay.getHoursByday()
                } else {
                    this.activeName = 'second'
                    this.$refs.byPeople.getHoursByPeople()
                }

            },
            // 重新计算数据
            async handleCalculateDataClick () {

                this.loading = true
                try {

                    let data = {
                        store_id: this.store_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        month: this.dateOne.format("YYYY-MM")
                    }

                    await http.post('/wapi/v1/calculateData', data).then(res => {

                        if (res.success) {
                            this.$message({
                                type: 'success',
                                message: '计算完成'
                            })
                        }
                        this.loading = false

                        if (this.activeName === "first") {

                            this.$refs.byDay.getWorkingHoursByday()
                        } else {

                            this.$refs.byPeople.getWorkingHoursByPeople()
                        }
                    })
                    //
                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            // 修改班次的背景色
            getBackground(color) {
                return 'rgb(' + color + ')'
            },
            // 返回按钮
            handleBackClick () {
                this.$router.push({
                    path: '/attendance'
                })
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';
    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;
        .body {

            .title {
                font-size:$fontSize;
                line-height:$fontSize;
                em {
                    display: inline-block;
                    margin-right: 50px;
                    color:#000000;
                }
                span {
                    display: inline-block;
                    color: #4a90e2;
                    margin-right: 30px;
                }
            }
            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                border-radius: 3px;
                padding: 4px;
                display: -moz-inline-box;
                display: inline-block;
                text-align: center;
                line-height: 15px;
                width: 50px;
            }
        }
    }
</style>
<style scoped>

    .channel {
        margin-top: 20px;
        font-size: 12px;
        color: #808080;
        vertical-align: middle;
    }
    .ware {
        display: flex;
        justify-content: center;
    }


</style>



// WEBPACK FOOTER //
// src/pages/attendance/hour/index.vue